import * as yup from 'yup';
import { requiredMsg } from '../../../../utils/validationMessages';

export const AnalystRatingSchema = yup.object().shape({
  esgRiskLevel: yup.string().required(requiredMsg('ESG Risk Level')),
  notes: yup.string(),
  esgOpportunitiesLevel: yup.string().required(requiredMsg('ESG Opportunities')),
});
